<template>
    <h2 class="text-3xl font-semibold text-primary text-left xl:pb-8 sm:pb-6">{{ title }}</h2>
</template>
<script>
export default {
    props: {
        title: String
    }
}
</script>
